<h1 mat-dialog-title>{{readOnly ? 'View JSON' : 'Edit JSON'}}</h1>

<div mat-dialog-content class="content">
  <json-editor class="editor" [options]="editorOptions()" (change)="handleChange($event)" [data]="initialValue"></json-editor>
</div>

<div mat-dialog-actions class="buttons">
  @if (readOnly) {
    <button mat-raised-button color="primary" (click)="close()">Close</button>
  } @else {
    <button mat-raised-button color="primary" (click)="save()">Apply</button>
    <button mat-button (click)="close()">Cancel</button>
  }
</div>
